import { observer } from "mobx-react-lite";
import { appState } from "@/app/appState";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

/** Shared public-site identity + legal links for Mollie / commercial compliance. */
export const LegalFooter = observer(function LegalFooter({
    showLanguageSwitcher = false,
}: {
    showLanguageSwitcher?: boolean;
}) {
    const dark = appState.theme === "dark";

    return (
        <footer className="footer">
            <p>{appState.t("marketing.footer.companyName")}</p>
            <p>{appState.t("marketing.footer.cvr")}</p>
            <p>{appState.t("marketing.footer.address")}</p>
            <p>
                <a
                    href={`mailto:${appState.t("marketing.footer.email")}`}
                    className="footer-link"
                >
                    {appState.t("marketing.footer.email")}
                </a>
            </p>
            <p>{appState.t("marketing.footer.currency")}</p>
            <p className="flex flex-row items-center gap-2 flex-wrap">
                <a
                    href="/signup"
                    className="footer-link"
                >
                    {appState.t("marketing.footer.prices")}
                </a>
                {dark ? " · " : " • "}
                <a
                    href="/standardvilkår"
                    className="footer-link"
                >
                    {appState.t("marketing.footer.terms")}
                </a>
                {dark ? " · " : " • "}
                <a
                    href="/privatlivspolitik"
                    className="footer-link"
                >
                    {appState.t("marketing.footer.privacy")}
                </a>
                {showLanguageSwitcher ? <LanguageSwitcher compact /> : null}
            </p>
        </footer>
    );
});
